import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 25000,
});

// Attach bearer token from localStorage as a fallback (cross-site cookies aren't always reliable)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "משהו השתבש. נסה שוב.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const uploadFileUrl = (filename) =>
  filename ? `${API}/uploads/${filename}` : "";

/**
 * Resolve a profile image reference (from user.profile_image) to a fully-qualified URL.
 * Handles three formats stored across the app's history:
 *   1. Full URL (http/https) - returned as-is
 *   2. Absolute path starting with "/" - returned as-is (browser resolves against current origin)
 *   3. Bare filename (uuid.ext) - resolved against the backend /uploads/ endpoint
 */
export const resolveProfileImage = (ref) => {
  if (!ref) return "";
  if (/^https?:\/\//i.test(ref)) return ref;
  if (ref.startsWith("/api/uploads/")) return `${API}${ref.replace(/^\/api/, "")}`;
  if (ref.startsWith("/")) return ref;
  return uploadFileUrl(ref);
};

export default api;
